import { MedicalType } from "@qendo/medical/types";
import { useLocalSearchParams } from "expo-router";
import { AllergyForm } from "~/components/form/health-profile/AllergyForm";
import { Authorize } from "~/components/permission/Authorize";
import { Dismiss } from "~/components/permission/Dismiss";
import { useDismiss } from "~/providers/DismissProvider";
import { useMedical } from "~/providers/MedicalProvider";

const type = MedicalType.allergy;

export default function EditAllergy() {
    const { id }: { id: string } = useLocalSearchParams();
    const { findMedical } = useMedical();
    const { handleDismiss } = useDismiss();
    const allergy = findMedical(type, id);

    if (!allergy) {
        return <Dismiss />;
    }

    return (
        <Authorize ability="update" section="allergies">
            <AllergyForm allergy={allergy} onRequestClose={handleDismiss} asRoute />
        </Authorize>
    );
}
